<template>
  <div>
    <v-container fluid class="pa-0">
      <div class="search-bar">
        <v-alert :value="!supplierTemplate" type="error" class="templateAlert">
          {{ this.$t("message.noTemplate") }}
        </v-alert>
        <v-layout row wrap>
          <v-flex xs12 sm12 md5>
              <img class="icon-seg" src="../assets/receipt-24px.svg">
              <span class="list-title">{{ this.$t("message.trackingTitle") }}</span>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex sx12 sm6 md3 px-3 >
            <v-btn solo color="primary"  @click="exportToCSV()">
              <span class="button-content">
                {{ this.$t("message.trackingExportButtonText") }}
              </span>
            </v-btn>
          </v-flex>
          <v-flex xs12 sm3 md2 px-3>
            <v-btn solo color="secondary" @click="showFilters = !showFilters">
              <span class="button-content">
                {{ this.$t("message.trackingToggleFiltersButtonText") }}
              </span>
              &nbsp;
              <v-icon>expand_more</v-icon>
            </v-btn>
          </v-flex>
          <v-flex sx12 sm3 md2 px-3>
            <v-btn
              :disabled="!supplierTemplate"
              solo
              color="primary"
              @click="goTo('fileLoader')"
            >
              <span class="button-content">
                {{ this.$t("message.trackingNewButtonText") }}
              </span>
              &nbsp;
              <v-icon>add</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </div>
    </v-container>

    <v-form v-if="showFilters">
      <div class="search-bar">
        <v-container fluid class="pa-0">
          <v-layout row wrap>
            <v-flex xs12 sm4 md4 pr-2>
              <v-text-field
                class="lance"
                v-model="search.invoiceNum"
                v-bind:label="$t('message.formInvoiceNo')"
                @input="searchOnTable"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 md4 px-1>
              <v-menu
                ref="dateMenu"
                :close-on-content-click="false"
                v-model="dateMenu"
                :nudge-right="40"
                :return-value.sync="search.date"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  class="lance"
                  slot="activator"
                  :value="formatDate(search.date)"
                  v-bind:label="$t('message.formInvoiceDate')"
                  append-icon="event"
                  readonly
                >
                </v-text-field>
                <v-date-picker
                  v-model="search.date"
                  no-title
                  scrollable
                  :locale="getLocaleString()"
                  :header-date-format="formatCalendarHeader"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    flat
                    color="primary"
                    @click="
                      search.date = null;
                      $refs.dateMenu.save(search.date);
                      searchOnTable();
                    "
                    >{{ this.$t("message.datetimePickerCancel") }}</v-btn
                  >
                  <v-btn
                    flat
                    color="primary"
                    @click="
                      $refs.dateMenu.save(search.date);
                      searchOnTable();
                    "
                    >{{ this.$t("message.datetimePickerAccept") }}</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm4 md4 pl-2>
              <v-select
                class="lance"
                :items="status"
                v-bind:item-text="$t('message.statusKey')"
                item-value="id"
                v-model="search.status"
                v-bind:label="$t('message.formStatus')"
                @input="searchOnTable"
                return-object
              >
                <v-list-tile
                  v-if="search.status"
                  slot="prepend-item"
                  @click="
                    search.status = null;
                    searchOnTable();
                  "
                >
                  <v-list-tile-action
                    ><v-icon>close</v-icon></v-list-tile-action
                  >
                  <v-list-tile-title>{{
                    this.$t("message.datetimePickerClean")
                  }}</v-list-tile-title>
                </v-list-tile>
                <v-divider
                  v-if="search.status"
                  slot="prepend-item"
                  class="mt-2"
                ></v-divider>
              </v-select>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
        </v-container>
      </div>
    </v-form>

  <div class="table-list table-adjust">
    <div class="text-xs-center header-table">
      <div style="display: flex; align-items:center">
        <div class="navigation-label">
            <span v-if="this.getLocaleString()==='es'">Elementos por página:</span>
            <span v-else>Rows per page:</span>
        </div>
        <div class="pr-4" style="width: 50px">
            <v-select
                class="customInput pa-0"
                v-model="pagination.rowsPerPage"
                :items="[10, 20, 30]"
            ></v-select>
        </div>

        <div class="nav-contPag" v-if="pagination.totalItems >  0">
            <span v-if="pageAct === pages"> {{(pageAct-1)*pagination.rowsPerPage + 1}} - {{pagination.totalItems}} </span>
            <span v-else> {{(pageAct-1)*pagination.rowsPerPage + 1}} - {{pageAct * pagination.rowsPerPage}} </span>
            <span v-if="this.getLocaleString()==='es'">de</span>
            <span v-else>of</span>
            <span> {{pagination.totalItems}}</span>
        </div>
        <div style="width: 145px; padding: 0px 10px" v-else>
            <span> 0 </span>
            <span v-if="this.getLocaleString()==='es'">de</span>
            <span v-else>of</span>
            <span> {{pagination.totalItems}}</span>
        </div>
      </div>
      <div style="display: flex; align-items:center">
        <div class="navPagOf" v-if="pagination.totalItems >  0">
            <span v-if="this.getLocaleString()==='es'"> Página: {{pageAct}} </span>
            <span v-else> Page: {{pageAct}} </span>
            <span v-if="this.getLocaleString()==='es'">de</span>
            <span v-else>of</span>
            <span> {{pages}}</span>
        </div>
        <div class="navPagOf" v-else>
            <span> Página: 0 </span>
            <span v-if="this.getLocaleString()==='es'">de</span>
            <span v-else>of</span>
            <span> 0 </span>
        </div>
      </div>

      <div style="min-width: 100px;">
          <v-btn color="primary" class="ma-0" icon flat @click="leftArrow();">
              <v-icon>keyboard_arrow_left</v-icon>
          </v-btn>
          <span><b>{{pageAct}}</b></span>
          <v-btn color="primary" class="ma-0" icon flat @click="rightArrow()">
              <v-icon>keyboard_arrow_right</v-icon>
          </v-btn>
          
      </div>
      
      <div style="width: 80px; margin-right: 5px">
          <span v-if="this.getLocaleString()==='es'">Ir página</span>
          <span v-else>Go page</span>
      </div>

      <div style="width: 70px; padding-right: 2px;">
        <v-text-field
        class="customInput pa-0"
        :rules="[numberRule]"
        v-model="toPage"
        @keyup.enter.native="goToPage()"
        hide-details
        ></v-text-field>
      </div>
      <div style="width: 100px; text-align: left">
          <v-btn v-if="this.getLocaleString()==='es'"
          outlined
          small
          fab
          @click="goToPage()"
          v-bind:class="{'active': (toPage > 0 && toPage <= pages)}"
          > Ir </v-btn>

          <v-btn v-else
          outlined
          small
          fab
          @click="goToPage()"
          v-bind:class="{'active': (toPage > 0 && toPage <= pages)}"
          > Go </v-btn>
      </div>
    </div>
  
    <v-data-table
      :headers="headers"
      :items="list"
      :loading="loading"
      :pagination.sync="pagination"
      hide-actions
    >
      <v-progress-linear
        slot="progress"
        color="primary"
        indeterminate
      ></v-progress-linear>
      <template slot="items" slot-scope="props">
        <tr>
          <td class="text-xs-left">{{ props.item.invoiceNum }}</td>
          <td class="text-xs-left">
            <v-container>
              <v-layout >
                <v-flex xs12 mt-2>
                  {{
                    props.item.purchaseOrder       ||
                    props.item.shipmentNum         ||
                    props.item.consignmentSheetNum ||
                    $t('message.noRelatedDoc')
                  }}
                </v-flex>
                <v-flex ml-5>
                  <related-doc-edit
                    v-if="isEditable( props.item.status, props.item.documentType )"
                    :document="props.item"
                    :supplierCode="supplierCode"
                    :relatedDoc="getRelatedDocType( props.item )"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </td>
          <!-- <td class="text-xs-left">
            <v-container>
              <v-layout>
                <v-flex>
                  {{ props.item.remission ||
                    $t('message.noRemissionAssinged')
                  }}
                </v-flex>
                <v-flex ml-5>
                  <remission-doc-edit
                    :document="props.item"
                    :supplierCode="supplierCode"
                    :remission="getRemissionNumber( props.item )"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </td> -->
          <td class="text-xs-left">{{ formatRegistrationDate(props.item.createdAt) }}</td>
          <td class="text-xs-left">{{ formatDate(props.item.date) }}</td>
          <td class="text-xs-left">{{ getStatus(props.item.status) }}</td>
          <td class="text-xs-left">{{ props.item.details || '-' }}</td>
          <td class="text-xs-left">{{ getPhase(props.item.phase) }}</td>
          <td class="text-xs-left">
            {{
              props.item.commentManual
                ? props.item.commentManual
                : $t("message.noComments")
            }}
          </td>
          <td class="text-xs-left">
          </td>
        </tr>
      </template>
      <template slot="no-data">
        {{ this.$t("message.dataTableNoData") }}
      </template>
    </v-data-table>
  </div>
  </div>
</template>

<style scoped>
.customInput  >>> .v-select__slot{
  margin-bottom: -10px;
}
.customInput  >>> .v-select__slot > .v-select__selections{
  padding-left: 5px;
}
.customInput >>> .v-text-field__slot > input {
  text-align: center !important;
  min-width: 45px;
}
.list-title{
  font-size: 21px;
  font-weight: bold;
  display: inline;
}
.icon-seg{
  width: 24px; 
  height: 24px; 
  vertical-align: text-bottom;
  margin-right: 10px;
}
.navPagOf{
  width: 125px;
}
.active{
  background-color: #fcc349b4 !important;
}
.header-table{
  background-color: #DEE0E3;
  display:flex; 
  align-items:center;         
  justify-content:flex-end;
  border-radius: 20px 20px 0px 0px; 
}
.navigation-label{
  width:160px; 
  display: flex; 
  align-items:center;
}
.nav-contPag{
  width: 145px;
  padding: 0px 10px;
}
@media screen and (max-width: 1100px) {
  .navigation-label{
      width: 120px;
  }
  .navPagOf{
      width: 60px;
  }
  .nav-contPag{
      width: 70px;
  }
}
.button-content {
  white-space: normal;
}
.templateAlert {
  border-radius: 50px;
  margin-bottom: 15px;
}
.table-adjust {
  padding-bottom: 20px !important;
  border-radius: 20px 20px 20px 20px !important;
  padding-top: 0px !important;
    }
</style>

<script>
import { events, printList } from "../main";
import { formatDate, formatRegistrationDate, formatCalendarHeader } from "../utils/util";
import _ from "underscore";
import xlsx from "xlsx";
import moment from "moment-timezone";
import { i18n } from "../utils/locales/default";
import RelatedDocEdit from './modals/RelatedDocEdit.vue';
import RemissionDocEdit from './modals/RemissionDocEdit.vue';

export default {
  components: {
    RelatedDocEdit,
    RemissionDocEdit,
  },
  data() {
    return {
      list: [],
      source: [],
      search: {
        invoiceNum: null,
        date: null,
        status: null,
      },
      status: [],
      showFilters: false,
      dateMenu: false,
      headers: [],
      pageAct: 1,
      toPage: null,
      isSearch: true,
      pagination: {
        sortBy: "createdAt",
        descending: true,
        rowsPerPage: 10,
        page: 1,
      },
      loading: true,
      deleteDialog: false,
      itemToDelete: "",
      supplierCode: localStorage.getItem("supplierCode"),
      supplierTemplate: localStorage.getItem("supplierTemplate") == "true",
      numberRule: v  => {
          if (v != undefined){
              if (!v.trim()) return true;
              if (!isNaN(parseFloat(v)) && v > 0 && v <= this.pages) return true;
              }
          return "false";
      },
      isNationalSupplier: null,
    };
  },
  watch: {
    pagination(newVal, oldVal){
      if(newVal.sortBy == null){
        newVal.descending = false;
        newVal.sortBy = oldVal.sortBy;
      }
      if(newVal.sortBy){
        this.list = [];
        this.loading = true;
        if(this.pageAct > 1)
          this.pageAct = 1;
        else{
          this.getList(0);
        }
      }
    },
    pageAct(newVal, oldVal) {
      this.getList(newVal - 1);
    },
    pages(newVal, oldVal) {
      if(!this.isSearch){
        if(this.pageAct == 1)
          this.getList(0);
        else
          this.pageAct = 1;
      }else
        this.isSearch = false;
    },
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },
  methods: {
    leftArrow(){
        if(this.pageAct > 1){
            this.pageAct--;
        }
    },rightArrow(){
        if(this.pageAct < this.pages){
            this.pageAct++;
        }
    },
    goToPage(){
        if(this.toPage){
            if(this.toPage > 0 && this.toPage <= this.pages)
                this.pageAct = Number(this.toPage);
            else{
              this.snackbar(this.$t('message.trackingInvalidPageNumber'));
            }
        }
    },
    snackbar: function (message) {
      events.$emit("snackbar", message);
    },
    goTo(url) {
      var self = this;
      self.$router.push("/" + url);
    },
    getLocaleString() {
      return i18n.locale;
    },
    updateHeadersLanguage() {
      this.headers = [
        {
          text: this.$t("message.trackingHeaderInvoiceNo"),
          value: "invoiceNum",
        },
        {
          text: this.$t("message.trackingHeaderRelatedDoc"),
          value: "relatedDoc",
          sortable: false,
        },
        // {
        //   text: this.$t("message.trackingHeaderRemission"),
        //   value: "remission",
        // },
        {
          text: this.$t("message.trackingHeaderUploadDate"),
          value: "createdAt",
        },
        { text: this.$t("message.trackingHeaderInvoiceDate"), value: "date" },
        { text: this.$t("message.trackingHeaderStatus"), value: "status" },
        { text: this.$t("message.trackingHeaderDetails"), value: "details" },
        { text: this.$t("message.trackingHeaderPhase"), value: "phase" },
        { text: this.$t("message.trackingHeaderManualNotes"), value: "commentManual" },
      ];
    },
    getList: function (oldVal) {
      if (oldVal === undefined) oldVal = 0;
      let invoiceEval = this.search.invoiceNum ? this.search.invoiceNum : "notSent";
      let dateEval = this.search.date ? this.search.date : "notSent";
      let statusEval = this.search.status ?this.search.status.id : "notSent";
      let orderBy = this.pagination.sortBy ? this.pagination.sortBy : "notSent";
          orderBy = orderBy == "supplier.businessName" ? "businessName" : orderBy;
      let desc = this.pagination.descending != null ? this.pagination.descending ? "DESC" : "ASC" : "notSent";

      const currentLocale = this.getLocaleString() || 'es';
      this.$http
        .get(
          "Documents/V2?page=" + oldVal + "&size=" + this.pagination.rowsPerPage + "&invoiceEval=" + invoiceEval + "&dateEval=" + dateEval + "&statusEval=" + statusEval + "&supplierCode=" + this.supplierCode + "&order=" + orderBy + "&desc=" + desc + "&locale=" + currentLocale
        )
        .then(
          (response) => {
            this.list = response.data.documents;
            this.source = response.data.documents;
            this.loading = false;
            this.pagination.totalItems = response.data.totalItems;

          },
          (error) => {
            this.snackbar(this.$t('message.trackingErrorGetList'));
            console.error(error);
          }
        );
    },
    getStatuses: function () {
      this.$http.get("Status").then(
        (response) => {
          var list = response.body;
          this.status = list;
        },
        (error) => {
          this.snackbar(this.$t('message.trackingErrorGetStatuses'));
          console.error(error);
        }
      );
    },
    searchOnTable: function () {
        this.isSearch = true;
        if(this.pageAct ===1)
          this.getList(0);
        this.pageAct = 1;
    },
    formatDate: function (date) {
      return formatDate(date);
    },
    formatRegistrationDate: function (date) {
      return formatRegistrationDate(date);
    },
    formatCalendarHeader: (val) => formatCalendarHeader(val),
    getStatus(value) {
      let s = this.status.find((x) => x.id == value);
      return s
        ? this.getLocaleString() == "en"
          ? s.englishText
          : s.spanishText
        : "";
    },
    getPhase(value) {
      if (value === null || value === undefined) {
        return ''; // En blanco cuando el estatus es exitoso
      }
      // Convertir a número para asegurar comparación correcta
      const phaseNum = Number(value);
      // Return only the number without "Fase" prefix
      return String(phaseNum);
    },
    exportToCSV() {

      let invoiceEval = this.search.invoiceNum ? this.search.invoiceNum : "notSent";
      let dateEval = this.search.date ? this.search.date : "notSent";
      let statusEval = this.search.status ?this.search.status.id : "notSent";
      let locale = this.getLocaleString();
      this.$http
        .get(
          "Documents/suppToCSV?invoiceEval=" + invoiceEval + "&dateEval=" + dateEval + "&statusEval=" + statusEval + "&supplierCode=" + this.supplierCode + "&locale=" + locale
        ).then(
          (response) => {
              let blob = new Blob([response.body], { type:"text/csv" })
              let link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.download = 'seguimiento.csv'
              link.click()
          },
          (error) => {
            if(locale === "es")
              this.snackbar(this.$t('message.trackingErrorProcessCSV'));
            else
              this.snackbar(this.$t('message.trackingErrorProcessCSV'));
              console.error(error);
          }
        );
    },
    isEditable( currentStatus, documentType ) {

      if ( documentType !== 1) {
        return false;
      }

      let notEditableStatuses = [ '1', '4', '5', '8', '13', '20' ];

      if ( notEditableStatuses.includes( currentStatus ) ) {
        if ( currentStatus !== '1' && currentStatus !== '20' && !this.isNationalSupplier ) {
          return true;
        } 
        return false;
      }
      return true;
    },
    getSupplierType() {
      this.$http.get( `SupplierType/getSupplierType/${this.supplierCode}` ).then(
        (response) => {
          this.isNationalSupplier = response.body.supplierType == 1;
        },
        (error) => {
          this.snackbar( this.$t( 'message.getSupplierCodeErrorMessage' ) );
          console.error(error);
        }
      );
    },
    getRelatedDocType( document ) {
      if ( document.purchaseOrder && !document.shipmentNum && !document.consignmentSheetNum ) {
        return { type: 'purchaseOrder', value: document.purchaseOrder };
      } else if ( !document.purchaseOrder && document.shipmentNum && !document.consignmentSheetNum ) {
        return { type: 'shipmentNum', value: document.shipmentNum };
      } else if ( !document.purchaseOrder && !document.shipmentNum && document.consignmentSheetNum && !document.isVMI ) {
        return { type: 'consignmentSheetNum', value: document.consignmentSheetNum };
      } else if ( document.isVMI ) {
        return { type: 'isVMI', value: document.consignmentSheetNum };
      } else {
        return { type: 'none', value: null };
      }
    },
    getRemissionNumber( document ) {
      if ( !document.remission || document.remission === null ) {
        return { type: 'remission', value: null }
      }

      return { type: 'remission', value: document.remission }
    },
  },
  mounted() {
    this.getStatuses();
    this.getList();
    this.getSupplierType();
    this.updateHeadersLanguage();

    events.$on("updateLanguage", () => {
      this.updateHeadersLanguage();
    });
  },
  filters: {
    moment: function (date) {
      return moment(date).locale(this.getLocaleString()).format("LL");
    },
  },
};
</script>